import { SharedProjektService } from '@/shared/api/services/projekt';
import type { Projekt, ZugeordneteBuergschaftIdsZuProjekt } from '@/types/Projekt.ts';

export class ProjektService extends SharedProjektService {
  async holeProjekt(id: string): Promise<Projekt> {
    return this.httpClient.get(`${this.projektServiceBaseUrl}/projekte/${id}`);
  }

  async entferneBuergschaftenVonProjekt(
    projektId: string,
    buergschaftIds: string[],
  ): Promise<number[]> {
    return this.httpClient.delete(
      `${this.projektServiceBaseUrl}/projekte/${projektId}/buergschaften`,
      {
        params: { buergschaftIds: buergschaftIds.join(',') },
      },
    );
  }

  async holeProjekteFuerZugeordneteUnternehmen(
    zugeordneteUnternehmenIds: string[],
  ): Promise<Projekt[]> {
    return this.httpClient.post(`${this.projektServiceBaseUrl}/projekte-fuer-zuordnung`, {
      data: zugeordneteUnternehmenIds,
    });
  }

  async fuegeBuergschaftenZuProjektHinzu(
    projektId: string,
    buergschaften: number[],
  ): Promise<number[]> {
    return this.httpClient.post(
      `${this.projektServiceBaseUrl}/projekte/${projektId}/buergschaften`,
      { params: { buergschaftIds: buergschaften.join(',') } },
    );
  }

  async findeZugeordneteBuergschaftIds(): Promise<number[]> {
    return this.httpClient.get(`${this.projektServiceBaseUrl}/projekte/buergschaften`);
  }

  async findeZugeordneteBuergschaftIdsZuProjekt(projektId: string): Promise<number[]> {
    return this.httpClient.get(`${this.projektServiceBaseUrl}/projekte/${projektId}/buergschaften`);
  }

  async findeZugeordneteUnternehmenIdsZuProjekt(projektId: string): Promise<string[]> {
    return this.httpClient.get(`${this.projektServiceBaseUrl}/projekte/${projektId}/unternehmen`);
  }

  async findeEingegangeneUndAusgestellteBuergschaftIdsZuProjekt(
    projektId: string,
  ): Promise<ZugeordneteBuergschaftIdsZuProjekt> {
    return this.httpClient.get(
      `${this.projektServiceBaseUrl}/projekte/${projektId}/buergschaften/einundaus`,
    );
  }

  async erstelleProjekt(projekt: Projekt): Promise<Projekt> {
    return this.httpClient.post(`${this.projektServiceBaseUrl}/projekte`, { data: projekt });
  }

  async aktualisiereProjekt(projekt: Projekt): Promise<void> {
    return this.httpClient.put(`${this.projektServiceBaseUrl}/projekte`, { data: projekt });
  }

  async loescheProjekt(projektId: string): Promise<void> {
    return this.httpClient.post(`${this.projektServiceBaseUrl}/projekte/${projektId}`);
  }
}
